export default __webpack_public_path__ + "static/media/courseHybridIcon.0a48caac.svg";